module.exports = __webpack_public_path__ + "01d64eb8accc7df3045512b39d2e2e44.svg";